const labelsValidationFR = {
    "name": {
        "required": "Le nom du label est requis",
        "unique": "Oups ! Ce label existe déjà et appartient à un autre utilisateur. Veuillez essayer un autre nom de label. Si vous possédez légalement ce nom de label et que vous détenez le droit d'auteur du nom, veuillez contacter notre équipe de support.",
        "available": "Le nom du label est disponible",
        "invalid": "Le nom du label est invalide"
    },
    "year": {
        "required": "L'année de création est requise",
        "numeric": "La valeur n'est pas un nombre",
        "stringLength": "L'année de création doit comporter 4 chiffres"
    },
    "releaseCatalog": {
        "required": "Les sorties dans le catalogue sont requises",
        "numeric": "La valeur n'est pas un nombre"
    },
    "logo": {
        "required": "Le logo est requis",
        "dimensions": "La taille du logo du label doit être de 1000 x 1000 px, JPG/JPEG/PNG.",
        "choose": "Veuillez choisir une image",
        "file": "Veuillez télécharger des formats JPG ou PNG, résolution minimale 1000x1000px. Taille max 2MB"
    },
    "promo_graphic": {
        "dimensions": "La taille du graphique promotionnel du label doit être de 960 x 150 px, JPG/JPEG/PNG.",
        "choose": "Veuillez choisir une image",
        "file": "Téléchargez des formats JPG ou PNG, résolution minimale 960x150px"
    }
};

export default labelsValidationFR;